module.exports = __webpack_public_path__ + "static/icon-physiooutcome-7bd1363b13744f03ca615b4bd98ba1b7.svg";